import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

// Always the production host, so UAT pages point search engines at prod.
const CANONICAL_HOST = 'https://tsaprecheckbyclear.tsa.dhs.gov'

// Keep in sync with PUBLIC_PAGES in sitemap-config.js.
const CANONICAL_PATHS = [
  '/',
  '/about',
  '/contact-us',
  '/help',
  '/important-notices',
  '/ktn-lookup',
  '/locations',
  '/status',
  '/terms',
]

/**
 * Meta data component
 */
const Meta = () => {
  const { pathname } = useRouter()
  const hasCanonical = CANONICAL_PATHS.includes(pathname)

  return (
    <React.Fragment>
      <Head>
        <meta charSet="utf-8" />
        {hasCanonical && (
          <link
            key="canonical"
            rel="canonical"
            href={`${CANONICAL_HOST}${pathname}`}
          />
        )}
      </Head>
    </React.Fragment>
  )
}

export default Meta
